import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import React, { useMemo } from 'react';
import { TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([TooltipComponent, PieChart, CanvasRenderer]);

interface ChartData {
  [key: string]: { averageMarks: number };
}

const DepartmentwiseChart = ({
  data,
  loading
}: {
  data: ChartData | null;
  loading: boolean;
}) => {
  const obtainedData = useMemo(() => {
    if (data) {
      return Object.keys(data).map(info => ({
        value: data[info]?.averageMarks || 0,
        name: info
      }));
    }
    return [];
  }, [data]);

  const isNoData =
    !data ||
    Object.keys(data).length === 0 ||
    obtainedData.every(item => item.value === 0);

  const getDefaultOptions = (getThemeColor: (name: string) => string) => ({
    color: [
      getThemeColor('info-light'),
      getThemeColor('warning-light'),
      getThemeColor('danger-light'),
      getThemeColor('success-light'),
      getThemeColor('primary')
    ],
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c}'
    },
    responsive: true,
    maintainAspectRatio: false,
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['50%', '90%'],
        startAngle: 30,
        avoidLabelOverlap: false,
        label: { show: false },
        emphasis: { label: { show: false } },
        labelLine: { show: false },
        data: obtainedData
      }
    ],
    grid: { bottom: 0, top: 0, left: 0, right: 0, containLabel: false }
  });

  const { getThemeColor } = useAppContext();

  if (loading) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ height: '320px' }}
      >
        <div className="donut-chart-skeleton"></div>
      </div>
    );
  }

  if (isNoData) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ height: '320px' }}
      >
        <p className="mt-2 text-muted">No Records</p>
      </div>
    );
  }

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getDefaultOptions(getThemeColor)}
      style={{ minHeight: '320px', width: '100%' }}
    />
  );
};

export default DepartmentwiseChart;
